import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumBrewmanBarcodeType implements BaseEnumType {
  private static allValues: EnumBrewmanBarcodeType[] = []; // make sure this is top-most
  
  public static none = new EnumBrewmanBarcodeType(0, "None", "enum_brewman_barcode_type_none");
  public static v6JourneyLabel = new EnumBrewmanBarcodeType(1, "V6JourneyLabel", "enum_brewman_barcode_type_v6_journey_label");
  public static v6PermLabel = new EnumBrewmanBarcodeType(2, "V6PermLabel", "enum_brewman_barcode_type_v6_perm_label");
  public static tracking = new EnumBrewmanBarcodeType(11, "Tracking", "enum_brewman_barcode_type_tracking");
  public static batch = new EnumBrewmanBarcodeType(22, "Batch", "enum_brewman_barcode_type_batch");
  public static pallet = new EnumBrewmanBarcodeType(33, "Pallet", "enum_brewman_barcode_type_pallet");
  public static ullage = new EnumBrewmanBarcodeType(44, "Ullage", "enum_brewman_barcode_type_ullage");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumBrewmanBarcodeType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumBrewmanBarcodeType.none; }
  public isV6JourneyLabel() { return this === EnumBrewmanBarcodeType.v6JourneyLabel; }
  public isV6PermLabel() { return this === EnumBrewmanBarcodeType.v6PermLabel; }
  public isTracking() { return this === EnumBrewmanBarcodeType.tracking; }
  public isBatch() { return this === EnumBrewmanBarcodeType.batch; }
  public isPallet() { return this === EnumBrewmanBarcodeType.pallet; }
  public isUllage() { return this === EnumBrewmanBarcodeType.ullage; }

  public static getValues(): readonly EnumBrewmanBarcodeType[] {
    return EnumBrewmanBarcodeType.allValues;
  }

  public static getValuesExcept0(): readonly EnumBrewmanBarcodeType[] {
    return EnumBrewmanBarcodeType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumBrewmanBarcodeType {
    const found = EnumBrewmanBarcodeType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumBrewmanBarcodeType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumBrewmanBarcodeType): EnumBrewmanBarcodeType {
    const found = name ? EnumBrewmanBarcodeType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumBrewmanBarcodeType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumBrewmanBarcodeType>): boolean {
    return this.key === other?.key;
  }
}